"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoLinkExpirySettings = exports.HELP_PROMPT_STRING = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var luxon_1 = require("luxon");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryEventName_1 = require("@CommonFrontendBackend/Telemetry/TelemetryEventName");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var IconToggle_1 = require("Common/IconToggle/IconToggle");
var PromptInline_1 = require("Common/Prompt/PromptInline");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var StringManipulater_1 = require("Utils/StringManipulater");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var TimeLimitInfoPrompt_1 = require("./TimeLimitInfoPrompt");
var TelemetryParameterKey_1 = require("Telemetry/TelemetryParameterKey");
var c = (0, BemBuilder_1.default)("auto-link-expiry");
var DAYS_TILL_EXPIRY_TEXT_MAPPING = (_a = {},
    _a[Types_1.ProjectStatus.Draft] = "Days after being set Live",
    _a[Types_1.ProjectStatus.Live] = "Days till page expires",
    _a);
function getExpiryDateText(autoLinkExpiryController) {
    var projectStatus = autoLinkExpiryController.projectStatus, daysUntilExpiry = autoLinkExpiryController.daysUntilExpiry, expiryDate = autoLinkExpiryController.expiryDate;
    if (projectStatus === Types_1.ProjectStatus.Draft) {
        return "Link expires ".concat((0, StringManipulater_1.pluralise)(daysUntilExpiry, "day"), " after being set live");
    }
    if (projectStatus === Types_1.ProjectStatus.Live) {
        if (!expiryDate)
            return "";
        var expiryDateTime = luxon_1.DateTime.fromJSDate(expiryDate);
        var hoursToExpiry = expiryDateTime.diffNow("hours").hours;
        if (hoursToExpiry >= 24) {
            return "Link expires on ".concat(expiryDateTime.toLocaleString(luxon_1.DateTime.DATE_FULL));
        }
        else {
            return "Link expires in ".concat((0, StringManipulater_1.pluralise)(Math.ceil(hoursToExpiry), "hour"));
        }
    }
    return "";
}
exports.HELP_PROMPT_STRING = "Expire pages after 'X' days when enabled. Pages that expire will go into a Declined state and can't be accessed publically";
exports.AutoLinkExpirySettings = (0, mobx_react_1.observer)(function (_a) {
    var autoLinkExpiryController = _a.autoLinkExpiryController;
    var projectStatus = autoLinkExpiryController.projectStatus, daysUntilExpiry = autoLinkExpiryController.daysUntilExpiry, enabled = autoLinkExpiryController.enabled, timeLimit = autoLinkExpiryController.timeLimit, wasTimeLimitDisabledThisSession = autoLinkExpiryController.wasTimeLimitDisabledThisSession;
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var initialSettingsRef = (0, react_1.useRef)({ daysUntilExpiry: daysUntilExpiry, enabled: enabled });
    (0, react_1.useEffect)(function () { return function () {
        var _a;
        var _b = initialSettingsRef.current, prevDaysUntilExpiry = _b.daysUntilExpiry, prevEnabled = _b.enabled;
        var currDaysUntilExpiry = autoLinkExpiryController.daysUntilExpiry, currEnabled = autoLinkExpiryController.enabled, isTemplate = autoLinkExpiryController.isTemplate, projectStatus = autoLinkExpiryController.projectStatus;
        var telemetryAttributes = (_a = {},
            _a[TelemetryParameterKey_1.ProjectExpiryChangedFields.IsTemplate] = isTemplate,
            _a[TelemetryParameterKey_1.ProjectExpiryChangedFields.PageState] = isTemplate ? undefined : projectStatus,
            _a[TelemetryParameterKey_1.ProjectExpiryChangedFields.Days] = currDaysUntilExpiry - prevDaysUntilExpiry,
            _a);
        if (prevEnabled !== currEnabled) {
            telemetryAttributes[TelemetryParameterKey_1.ProjectExpiryChangedFields.Action] = currEnabled ? "enabled" : "disabled";
        }
        else if (prevDaysUntilExpiry !== currDaysUntilExpiry) {
            telemetryAttributes[TelemetryParameterKey_1.ProjectExpiryChangedFields.Action] = "day_change";
        }
        telemetry.trackOnly(TelemetryEventName_1.TelemetryEventName.PageExpiryChanged, telemetryAttributes, {
            blockIntercom: true,
        });
    }; }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TimeLimitInfoPrompt_1.TimeLimitInfoPrompt, { timeLimit: timeLimit, wasTimeLimitDisabledThisSession: wasTimeLimitDisabledThisSession }),
        react_1.default.createElement(PromptInline_1.PromptInline, { promptId: PromptTypes_1.PromptId.AutoLinkExpirySettings, heading: "Link Expiry", content: exports.HELP_PROMPT_STRING }),
        react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.Clock, null), label: "Enable link expiry", value: enabled, onChange: function () { return autoLinkExpiryController.setEnabled(!enabled); }, disabled: ![Types_1.ProjectStatus.Draft, Types_1.ProjectStatus.Live].includes(projectStatus) }),
        enabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("number-input-row"), "space-stack-s") },
                react_1.default.createElement("span", { className: c("slate_label") }, DAYS_TILL_EXPIRY_TEXT_MAPPING[projectStatus] || ""),
                react_1.default.createElement("div", { className: c("number-input-container") },
                    react_1.default.createElement(NumberInput_1.default, { label: DAYS_TILL_EXPIRY_TEXT_MAPPING[projectStatus] || "", labelHidden: true, showStepper: true, size: kaleidoscope_1.TextInputSize.Medium, value: daysUntilExpiry, min: 1, max: 365, onChange: function (value) { return autoLinkExpiryController.setDaysUntilExpiry(value); } }))),
            react_1.default.createElement("div", { className: c("expiry-date-label") }, getExpiryDateText(autoLinkExpiryController))))));
});
